import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import Message from "../components/Message";
import CountdownTimer from "../components/utils/CountdownTimer";
import OTPInput from "../components/utils/OTPInput";
import logo from "../images/tipkit-logo-main.svg";
import { resendOTP, userLogin, verifyOTP } from "../redux/Actions/userAction";
import { generateUUID } from "../utils/genrateUUID";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [resendTimeInSeconds, setResendTimeInSeconds] = useState(30);
  const [rememberDevice, setRememberDevice] = useState(false);

  const login = useSelector((state) => state.userLogin);
  const {
    loading,
    error,
    userInfo,
    mfa,
    verifyOtpError,
    verifyOtpSuccess,
    resendLoading,
    resendOtpMessage,
    resendOtpError,
  } = login;
  const dispatch = useDispatch();
  const navigation = useNavigate();

  useEffect(() => {
    if (userInfo && !mfa?.required) {
      const redirectPath =
        userInfo.isSuperAdmin === true || userInfo.isPartner === true
          ? "/super-admin"
          : userInfo.isAdmin === true && userInfo.isAdminX === false
          ? "/dashboard"
          : userInfo.isAdminX === true && userInfo.isAdmin === true
          ? "/dashboard/adminx"
          : userInfo.isRoleUser === true
          ? "/dashboard"
          : "/";

      navigation(redirectPath);
    }

    if (error && !mfa?.required) {
      setMessage(error);
    }

    if (verifyOtpSuccess) {
      setMessage("OTP Verified Successfully!");
      // Redirection will happen in the userInfo check above
    }
    if (verifyOtpError) {
      setMessage(verifyOtpError);
    }
    if (resendOtpMessage) {
      setMessage(resendOtpMessage);
      setResendDisabled(true); // Disable after successful resend
    }
    if (resendOtpError) {
      setMessage(resendOtpError);
    }
  }, [
    userInfo,
    navigation,
    dispatch,
    error,
    mfa,
    verifyOtpSuccess,
    verifyOtpError,
    resendOtpMessage,
    resendOtpError,
  ]);

  const [message, setMessage] = useState(null);

  const submitHandler = (e) => {
    e.preventDefault();

    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      deviceId = generateUUID();
      localStorage.setItem("deviceId", deviceId);
    }

    dispatch(userLogin({ email, password, deviceId }));
    setMessage(null);
    setOtp("");
    setResendDisabled(true);
    setResendTimeInSeconds(30);
  };

  const verifyOTPHandler = (e) => {
    e.preventDefault();
    if (mfa?.userId) {
      const deviceId = localStorage.getItem("deviceId");
      dispatch(
        verifyOTP(mfa.userId, otp, mfa.isRoleUser, rememberDevice, deviceId)
      );
      setMessage(null);
    } else {
      setMessage("Something went wrong. Please log in again.");
    }
  };

  const handleResendOTPClick = () => {
    if (mfa?.userId && !resendDisabled) {
      dispatch(resendOTP(mfa.userId, mfa.isRoleUser));
      setMessage(null);
      setResendDisabled(true);
      setResendTimeInSeconds(30); // Reset timer on resend
    }
  };

  const styles = {
    shadow: {
      boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
    },
  };

  return (
    <>
      <Row className="justify-content-center align-items-center vh-100 m-0 bg-light ">
        <Col
          xl={4}
          lg={6}
          md={8}
          sm={10}
          xs={12}
          className="pt-5 rounded-5 border border-1 bg-white"
          style={styles.shadow}
        >
          <Row className="justify-content-center mb-5">
            <Col xs="auto">
              <img src={logo} alt="tipkit" width="250" />
            </Col>
          </Row>
          <Row>
            <Col className="px-5">
              {message && (
                <Message variant={mfa?.required ? "info" : "danger"}>
                  {message}
                </Message>
              )}
              {/* {loading && <Loader />} */}
            </Col>
          </Row>

          {!mfa?.required ? (
            <Form className="px-4" onSubmit={submitHandler}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label className="fw-bold">Email</Form.Label>
                <Form.Control
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label className="fw-bold ">Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    className="position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? (
                      <FontAwesomeIcon icon={faEye} />
                    ) : (
                      <FontAwesomeIcon icon={faEyeSlash} />
                    )}
                  </span>
                </div>
                <span
                  className="text-muted fs-7 text-decoration-underline hover-effect"
                  onClick={() => navigation("/reset-password")}
                >
                  Forgot password?
                </span>
              </Form.Group>
              <Row className="justify-content-center px-3 mb-3 pt-4">
                <Button
                  className="py-2"
                  variant="primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <Loader size="sm" /> : "Login"}
                </Button>
              </Row>
            </Form>
          ) : (
            <Form className="px-4" onSubmit={verifyOTPHandler}>
              <Form.Group className="mb-3 w-100" controlId="formBasicOTP">
                <Form.Label className="fw-bold">
                  OTP (One-Time Password)
                </Form.Label>
                <OTPInput length={6} onChange={(val) => setOtp(val)} />
              </Form.Group>
              {/* <Form.Group className="mb-3" controlId="formBasicRememberDevice">
                <Form.Check
                  type="checkbox"
                  label="Remember this device"
                  onChange={(e) => setRememberDevice(e.target.checked)}
                />
              </Form.Group> */}
              <Col md="auto" className="text-center">
                {resendDisabled ? (
                  <CountdownTimer
                    className="fs-6"
                    message="Resend OTP in"
                    durationInSeconds={resendTimeInSeconds}
                    onComplete={() => setResendDisabled(false)}
                  />
                ) : (
                  <Button
                    size="sm"
                    variant="link"
                    onClick={handleResendOTPClick}
                    disabled={resendLoading}
                  >
                    {resendLoading ? <Loader size="sm" /> : "Resend OTP"}
                  </Button>
                )}
              </Col>
              <Col
                md="auto"
                className="mt-4 row justify-content-center px-3 mb-3"
              >
                <Button
                  className="py-2"
                  variant="primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <Loader size="sm" /> : "Verify OTP"}
                </Button>
              </Col>
            </Form>
          )}

          <Row className="mt-5 pb-2">
            <Col className="text-center" style={{ fontSize: "13px" }}>
              <a
                className="text-decoration-none text-primary"
                href="https://tipkit.co/terms"
                target="_blank"
              >
                Terms of use
              </a>{" "}
              and{" "}
              <a
                className="text-decoration-none text-primary"
                href="https://tipkit.co/privacy-policy"
                target="_blank"
              >
                Privacy Policy
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Login;
